import CircularProgress from '@material-ui/core/CircularProgress'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import BlockIcon from '@material-ui/icons/Block'
import AvailabilityIcon from '@material-ui/icons/EventAvailable'
import MoneyIcon from '@material-ui/icons/LocalAtm'
import SyncIcon from '@material-ui/icons/Sync'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    dobovoPushYearAvailability,
    dobovoPushYearPrices,
    dobovoPushYearRestrictions,
    dobovoSynchronizeProperty
} from '../../../../../api/dobovoApi/dobovoSync'
import { selectCurrentOrganization } from '../../../../../selectors/dobovoSelectors/dobovoCurrentOrganization'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        width: '95%'
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class SyncTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dobovoPushYearPrices: PropTypes.func,
        dobovoPushYearRestrictions: PropTypes.func,
        dobovoPushYearAvailability: PropTypes.func,
        dobovoSynchronizeProperty: PropTypes.func,
        pendingPushYearPrices: PropTypes.bool,
        pendingPushYearRestrictions: PropTypes.bool,
        pendingPushYearAvailability: PropTypes.bool,
        pendingSynchronizeProperty: PropTypes.bool,
        organizationId: PropTypes.string.isRequired
    }

    handlePushYearPrices = () => this.props.dobovoPushYearPrices({ propertyId: this.props.organizationId })

    handlePushYearRestrictions = () =>
        this.props.dobovoPushYearRestrictions({ propertyId: this.props.organizationId })

    handlePushYearAvailability = () =>
        this.props.dobovoPushYearAvailability({ propertyId: this.props.organizationId })

    handleSynchronizeProperty = () =>
        this.props.dobovoSynchronizeProperty({ propertyId: this.props.organizationId })

    render() {
        const {
            classes,
            pendingPushYearPrices,
            pendingPushYearRestrictions,
            pendingPushYearAvailability,
            pendingSynchronizeProperty
        } = this.props

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <List>
                        <ListItem button onClick={this.handlePushYearPrices} disabled={pendingPushYearPrices}>
                            <ListItemIcon>
                                <MoneyIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить цены"
                                secondary="Это действие отправляет цены в Dobovo.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearPrices && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handlePushYearRestrictions}
                            disabled={pendingPushYearRestrictions}
                        >
                            <ListItemIcon>
                                <BlockIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить ограничения"
                                secondary="Это действие отправляет ограничения в Dobovo.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearRestrictions && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handlePushYearAvailability}
                            disabled={pendingPushYearAvailability}
                        >
                            <ListItemIcon>
                                <AvailabilityIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить доступность"
                                secondary="Это действие отправляет доступность в Dobovo.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearAvailability && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={this.handleSynchronizeProperty} disabled={pendingSynchronizeProperty}>
                            <ListItemIcon>
                                <SyncIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить всё"
                                secondary="Это действие отправляет цены, ограничения и доступность в Dobovo.com на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingSynchronizeProperty && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    organizationId: selectCurrentOrganization(state),
    pendingPushYearPrices: state.dobovoSync.pendingPushYearPrices,
    pendingPushYearRestrictions: state.dobovoSync.pendingPushYearRestrictions,
    pendingPushYearAvailability: state.dobovoSync.pendingPushYearAvailability,
    pendingSynchronizeProperty: state.dobovoSync.pendingSynchronizeProperty
})

export default connect(
    mapStateToProps,
    {
        dobovoPushYearPrices,
        dobovoPushYearRestrictions,
        dobovoPushYearAvailability,
        dobovoSynchronizeProperty
    }
)(withStyles(styles)(SyncTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/SyncTab/SyncTab.js